

export function SET_ENVOLVIDO_LIST(state, list) {
  state.envolvidos = list;
}

export function SET_ENVOLVIDO(state, obj) {
  state.envolvido = obj;
}
